export default __webpack_public_path__ + "static/media/gallery-wip-grenade cap_04.ec284321.jpg";